import { Clients } from "../organism/Clients";
import { Footer } from "../organism/Footer";
import { Hero } from "../organism/Hero";
import { SectionFive } from "../organism/SectionFive";
import { SectionOne } from "../organism/SectionOne";
import { SectionThree } from "../organism/SectionThree";
import { SectionTwo } from "../organism/SectionTwo";
import { Sellaris } from "../organism/Sellaris";

export default function Home() {
    return (
        <>
            <Hero/>
            <Clients/>
            <SectionTwo/>
            <Sellaris/>
            <SectionThree/>
            <SectionOne/>
            <SectionFive/>
            <Footer/>
        </>
    );
}
